<template>
	<v-card class="elevation-0 agenda-page agenda-page-container page">
		<PageBlocked v-if="isBlocked" :blockRole="blockRole" />
		<Agendas v-else-if="isBlocked !== null" />
	</v-card>
</template>

<script>
import Agendas from '@/components/Event/Agendas.vue'
import PageBlocked from '@/components/PageBlocked'
import Block from '@/mixins/Block.js'
import { mapActions } from 'vuex'
export default {
	mixins: [Block],
	components: {
		Agendas,
		PageBlocked,
	},
	data() {
		return {
			pageBlockedName: 'events',
		}
	},
	methods: {
		...mapActions('app', ['setPageTitle']),
	},
	mounted() {
		this.setPageTitle('Agenda')
	},
	beforeDestroy() {
		this.setPageTitle('')
	},
}
</script>
<style lang="scss">
.agenda-page {
	@media (max-width: 768px) {
		padding-top: 4px;
	}
}
</style>
